import { SocialNetworkConnectionStatus } from '../../../enums/social-network/social-network-connection-status.enum';
import { SocialNetworkEntityType } from '../../../enums/social-network/social-network-entity-type.enum';
import { SocialNetworkInstancePrivacyType } from '../../../enums/social-network/social-network-instance-privacy-type.enum';
import { SocialNetworkThreadOwnerType } from '../../../enums/social-network/social-network-thread-owner-type.enum';
import { SocialNetworkInstance } from '../social-network-instance';
import { SocialNetworkInstanceImage } from '../social-network-instance-image';
import { SpecialtyOrRoleLevel } from './specialty-or-role-level';

export class EntityInstance {
  public token: string;
  public name: string;
  public description: string;
  public privacy: SocialNetworkInstancePrivacyType;
  public createdAt: Date;
  public updatedAt: Date;
  public editable: boolean;
  public deletable: boolean;
  public instancesId?: string;
  public instance: SocialNetworkInstance;
  public images?: SocialNetworkInstanceImage[];
  public status: SocialNetworkConnectionStatus;
  public following: boolean;
  public externalId?: string;
  public numberOfMembers?: number;
  public membersIds?: string[];
  public shortDescription?: string;
  public about?: string;
  public owner?: boolean;
  public administrator?: boolean;
  public ownerType?: SocialNetworkThreadOwnerType;
  public ownerId?: string;
  public specialtyName?: string;
  public specialty: SpecialtyOrRoleLevel;
  public roleLevel: SpecialtyOrRoleLevel;
  public sourceHubId?: string;
  public type: SocialNetworkEntityType;
  public countryName: string;
}
